import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ActionCreator from "../../store/actions/index";
import {Button, Hidden, Popover, withStyles} from "@material-ui/core";
import {compose} from 'recompose';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import ArchiveIcon from '@material-ui/icons/Archive';
import SearchIcon from '@material-ui/icons/Search';
import {LocationOffOutlined, LocationOnOutlined} from "@material-ui/icons";
import FilterListIcon from '@material-ui/icons/FilterList';
import {themeTypeToBool} from '../../utils/helpers';
import {TooltipTop as CustomTooltip} from "../Common/CustomTooltips";
import FilterParameters from "./FilterParameters";
import Search from "./Search";
import t from "../../languages/pl";
import ResetFilters from "./ResetFilters";
import {withRouter} from "react-router-dom";
import FilterAddress from "./FilterAddress";

const useStyles = theme => ({
    container: {
        display: "flex",
        alignItem: "center",
    },
    button: {
        margin: theme.spacing(0.5),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
    buttonLabel: {
        color: "#FFF"
    },
    buttonDefault: {
        background: themeTypeToBool(theme.palette.type) ? "#43425D" : theme.palette.secondary[200]
    },
    userDetails: {
        position: "absolute",
        right: 35,
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "center"
    },
    iconButton: {
        minWidth: 30,
    },
    popover: {
        padding: theme.spacing(2),
    }
});


const Filter = props => {
    const {
        classes, selectedCar, searchField, onSearching, disableSearch,
        disableSelect, disableGearbox, showArchived, showPoiOnMap, showNotArchived, isMap,
        group, brand, model, gprs, fuelType, gearbox, street, city, postalCode, radius
    } = props;
    const [popoverAnchor, setPopoverAnchor] = useState(null);
    const [phrase, setPhrase] = useState("");

    useEffect(() => {
        if (searchField)
            setPhrase(searchField);
    }, [searchField]);

    useEffect(() => {
        if (selectedCar)
            props.setSearchField("");
    }, [selectedCar]);

    const handleGrabValue = value => {
        setPhrase(value);
    };

    const handleSearchClick = (description = '', address) => {
        if (isMap) {
            if (onSearching) {
                onSearching(description, address);
            }
        }

        props.setSearchField(phrase);
    };

    const handleResetClick = () => {
        if (isMap) {
            props.resetToDefaults();
            onSearching();
        } else {
            redirectToCars();
            setPhrase("");
            props.resetToDefaults();
            props.setSearchField("");
            //FIXME zastapic wyszukiwaniem
        }
    };

    const isFilterActive = () => {
        if (group || brand || model || gprs || fuelType || gearbox || street || city || postalCode || radius) return true;
    };

    const redirectToCars = () => {
        props.history.push({
            pathname: "/cars",
        });
    };

    return (
        <div className={classes.container}>
            {!disableSearch
                &&
                <Search
                    searchValue={phrase}
                    onSearchFieldChange={handleGrabValue}
                    onSearchStart={handleSearchClick}
                    disableSelect={disableSelect}
                />
            }
            <Hidden lgDown>
                <FilterParameters
                    disableGearbox={disableGearbox}
                    isGprs={true}
                />
            </Hidden>

            <CustomTooltip title={t.showFilters}>
                <Button
                    color={isFilterActive() ? 'primary' : 'default'}
                    className={classes.iconButton}
                    onClick={(e) => setPopoverAnchor(e.target)}
                >
                    <FilterListIcon/>
                </Button>
            </CustomTooltip>

            <Popover
                open={popoverAnchor !== null}
                anchorEl={popoverAnchor}
                onClose={() => setPopoverAnchor(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                classes={{paper: classes.popover}}
            >

                <Hidden xlUp>
                    <FilterParameters disableGearbox={disableGearbox} isGprs={true}/>
                </Hidden>

                { isMap ? <FilterAddress /> : <></> }

            </Popover>

            {props.children}

            <CustomTooltip title={showNotArchived ? t.hideNotArchived : t.showNotArchived}>
                <Button

                    className={classes.iconButton}
                    onClick={() => props.changeShowNotArchivedFilter()}
                >
                    <VerifiedUserIcon style={{color: showNotArchived ? "inherit" : "#b7b5b5"}}/>
                </Button>
            </CustomTooltip>

            <CustomTooltip title={showPoiOnMap ? t.hidePoiOnMap : t.showPoiOnMap}>
                <Button

                    className={classes.iconButton}
                    onClick={() => props.showPoiOnMapFilter()}
                >
                    {showPoiOnMap ?
                        <LocationOffOutlined/> :
                        <LocationOnOutlined/>}
                </Button>
            </CustomTooltip>

            <CustomTooltip title={showArchived ? t.hideArchived : t.showArchived}>
                <Button

                    className={classes.iconButton}
                    onClick={() => props.changeShowArchivedFilter()}
                >
                    <ArchiveIcon style={{color: showArchived ? "inherit" : "#b7b5b5"}}/>
                </Button>
            </CustomTooltip>

            <ResetFilters onReset={handleResetClick}/>
            {!disableSearch
                &&
                <CustomTooltip title={t.find}>
                    <Button
                        className={classes.iconButton}
                        onClick={handleSearchClick}
                    >
                        <SearchIcon/>
                    </Button>
                </CustomTooltip>
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        selectedCar: state.mapCarsReducer.selectedCar,
        cars: state.mapCarsReducer.cars,
        searchField: state.filterReducer.searchField,
        showArchived: state.filterReducer.showArchived,
        showNotArchived: state.filterReducer.showNotArchived,
        showPoiOnMap: state.filterReducer.showPoiOnMap,
        group: state.filterReducer.group,
        brand: state.filterReducer.brand,
        model: state.filterReducer.model,
        gprs: state.filterReducer.gprs,
        fuelType: state.filterReducer.fuelType,
        gearbox: state.filterReducer.gearbox,
        street: state.filterReducer.street,
        city: state.filterReducer.city,
        postalCode: state.filterReducer.postalCode,
        radius: state.filterReducer.radius,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

export default compose(
    withStyles(useStyles),
    withRouter,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(Filter);

Filter.propTypes = {
    //inputs
    onSearching: PropTypes.func,
    children: PropTypes.node,
    disableSearch: PropTypes.bool,
    disableGearbox: PropTypes.bool,
    disableSelect: PropTypes.bool,
    isMap: PropTypes.bool,
    //styles
    classes: PropTypes.object,
    //redux
    selectedCar: PropTypes.object,
    cars: PropTypes.array,
    searchField: PropTypes.string,
    showArchived: PropTypes.bool,
    showNotArchived: PropTypes.bool,
    showPoiOnMap: PropTypes.bool,
    setSearchField: PropTypes.func,
    resetToDefaults: PropTypes.func,
    changeShowNotArchivedFilter: PropTypes.func,
    changeShowArchivedFilter: PropTypes.func,
    showPoiOnMapFilter: PropTypes.func,
    //router
    history: PropTypes.object,
    // filters
    group: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    brand: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    model: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    gprs: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    fuelType: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    gearbox: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    street: PropTypes.string,
    city: PropTypes.string,
    postalCode: PropTypes.string,
    radius: PropTypes.string,
};
